import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { loadReport } from "../thunks/loadReportData";
import { WeeklyTradingReportData } from "../types";

export const useTradesReportData = () => {
  const data = useSelector<StoreType, WeeklyTradingReportData[] | undefined>(
    (s) => s.data.reports.weeklyTrade.data
  );

  const dispatch = useDispatch();
  const dispatchLoadData = React.useCallback(() => dispatch(loadReport()), [
    dispatch,
  ]);

  return [data, dispatchLoadData] as [typeof data, typeof dispatchLoadData];
};
